import React from 'react'

import { useInView } from 'react-cool-inview'

import { bool, number, string, func, arrayOf } from 'prop-types'

import { NOOP, EMPTY_ARRAY } from 'Utils/stableDefaults'

import OneTimeOption from './OneTimeOption/OneTimeOption'
import PURCHASE_OPTION from './purchaseOptions'
import SubscriptionOption from './SubscriptionOption/SubscriptionOption'

function SubscriptionPurchase({
  planName,
  subscriptionTierBand = 'essentials',
  subscriptionBullets = EMPTY_ARRAY,
  subscriptionPricePerModel,
  subscriptionPerModelLabel,
  subscriptionFromPriceLabel,
  subscriptionMonthlyPrice,
  subscriptionPriceUnit,
  showMonthlyPrice = false,
  subscriptionDownloadsPerMonth,
  subscriptionCatalogValue,
  productPrice = null,
  productOriginalPrice = null,
  hasDiscount = false,
  selectedOption,
  onOptionChange: handleOptionChange,
  onImpression = NOOP,
}) {
  // Fires the impression once the plan selector is at least 50% visible. The
  // selector only renders when the item is in the subscription and the user has
  // no active subscription, so the event represents exactly that acquisition case.
  const { observe } = useInView({
    threshold: 0.5,
    onEnter: ({ unobserve }) => {
      unobserve()
      onImpression()
    },
  })

  return (
    <div ref={observe} className="subscription-purchase">
      <SubscriptionOption
        selected={selectedOption === PURCHASE_OPTION.SUBSCRIPTION}
        onSelect={() => handleOptionChange(PURCHASE_OPTION.SUBSCRIPTION)}
        planName={planName}
        band={subscriptionTierBand}
        bullets={subscriptionBullets}
        pricePerModel={subscriptionPricePerModel}
        perModelLabel={subscriptionPerModelLabel}
        fromLabel={subscriptionFromPriceLabel}
        monthlyPrice={subscriptionMonthlyPrice}
        priceUnit={subscriptionPriceUnit}
        showMonthlyPrice={showMonthlyPrice}
        downloadsPerMonth={subscriptionDownloadsPerMonth}
        catalogValue={subscriptionCatalogValue}
      />

      <OneTimeOption
        selected={selectedOption === PURCHASE_OPTION.ONETIME}
        onSelect={() => handleOptionChange(PURCHASE_OPTION.ONETIME)}
        price={productPrice}
        originalPrice={productOriginalPrice}
        hasDiscount={hasDiscount}
      />
    </div>
  )
}

SubscriptionPurchase.propTypes = {
  planName: string.isRequired,
  subscriptionTierBand: string,
  subscriptionBullets: arrayOf(string),
  subscriptionPricePerModel: string.isRequired,
  subscriptionPerModelLabel: string.isRequired,
  subscriptionFromPriceLabel: string.isRequired,
  subscriptionMonthlyPrice: string.isRequired,
  subscriptionPriceUnit: string.isRequired,
  showMonthlyPrice: bool,
  subscriptionDownloadsPerMonth: number.isRequired,
  subscriptionCatalogValue: string.isRequired,
  productPrice: string,
  productOriginalPrice: string,
  hasDiscount: bool,
  selectedOption: string.isRequired,
  onOptionChange: func.isRequired,
  onImpression: func,
}

export default SubscriptionPurchase
